/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  /**
   * Вид для формы запроса дополнительных данных при регистрации через соцсети
   */
  app.SocSignupFormView = app.ValidatedFormView.extend({
    el: '#soc-signup-form',
    formName: 'soc-signup',
    formElement: '.field_input',
    
    events: {
      'click .button_blue': 'save',
      'blur .input': 'validate',
      'blur .input_phone': 'changeInfoMessage',
      'change #soc-signup-isAcceptAgreement': 'toggleAgreementError'
    },
    
    run: function () {
      this.childViews = {};
      this.lastData = null;
      this.currentData = null;
      this.agreementCheckbox = this.$('#soc-signup-isAcceptAgreement');
      this.agreementErrorField = this.$('#soc-signup-accept-agreement-error');
      this.listenToOnce(this.model, 'sync', this.pushDataOko);
      app.ValidatedFormView.prototype.run.apply(this);
      this.childViews.phoneInputmaskView = new app.PhoneInputmaskView();
      this.childViews.choiceCountryView = new app.ChoiceCountryView({'el': this.$('.choice-country')});
      this.fillFieldsFromSocNet();
      this.hasDoubleAuthError = false;
    },
  
    /**
     * Отправка данных в око
     */
    pushDataOko: function () {
      if (this.model.get('id')) {
        app.helpers.OkoHelper.push({
          'n': 'new-user',
          'user-id': parseInt(this.model.get('id'), 10),
        });
      }
    },
    
    /**
     * Заполняет поля данными пришедшими после авторизации в соцсети.
     */
    fillFieldsFromSocNet: function () {
      if (this.model.get('phone')) {
        this.$('#soc-signup-phone').val(this.model.get('phone'));
      }
      if (this.model.get('email')) {
        this.$('#soc-signup-email').val(this.model.get('email'));
      }
    },
  
    /**
     * Меняет надпись под формой ввода телефона в зависимости от того мобильный номер или нет
     */
    changeInfoMessage: function (event) {
      var start = app.countryFlag.attributes.code.length - 1,
        end = start + 3,
        phoneCode = parseInt($(event.target).val().substring(start, end)),
        phoneNumberLength = $(event.target).val().length,
        checkForMobile = app.helpers.isMobileHelper.isMobile(phoneCode, phoneNumberLength),
        callAndSms = this.$('.call-and-sms'),
        onlyCall = this.$('.only-call');
      if (checkForMobile) {
        callAndSms.show();
        onlyCall.hide();
        return;
      }
      callAndSms.hide();
      onlyCall.show();
    },
  
    /**
     * Возвращает true если подтверждено согласие на обработку персональных данных
     *
     * @return boolean
     */
    isAgreementsAccepted: function () {
      return this.agreementCheckbox.prop('checked');
    },
  
    /**
     * Переключение видимости сообщения о согласии на обработку персональных данных.
     */
    toggleAgreementError: function () {
      this.agreementErrorField.hide();
      if (!this.isAgreementsAccepted()) {
        this.agreementErrorField.show();
      }
    },
  
    /**
     * Проверяет данные, если они не изменялись, возвращает true.
     *
     * @return boolean
     */
    hasNoNewData: function () {
      this.currentData = this.getData();
      return (this.lastData && _.isEqual(this.lastData, this.currentData));
    },
  
    /**
     * Сохранение формы.
     * @param e
     */
    save: function(e) {
      e.preventDefault();
      if (!this.isAgreementsAccepted() || this.hasNoNewData()) {
        if (this.hasNoNewData()) {
          if (this.model.get('id')) {
            this.successRedirect();
          } else {
            this.cooldownSave(e);
          }
        }
        return;
      }
      this.lastData = this.currentData;
      if (this.onValidate) {
        this.cooldownSave(e);
        return;
      }
      app.ValidatedFormView.prototype.save.apply(this);
    },
    
    /**
     * Редирект в зависимости от параметра, переданного от контроллера.
     */
    successRedirect: function () {
      app.helpers.RedirectHelper.locationAssign(this.$el.data('return-url') || '/cabinet/');
    },
    
    /**
     * При успешной авторизации редирект в кабинет
     */
    success: function () {
      if (this.onSave) {
        this.successRedirect();
      }
      app.ValidatedFormView.prototype.success.apply(this);
    },
    
    /**
     *  Задержка для сохранения формы, из-за перекликания с валидацией
     * @param e
     */
    cooldownSave: function (e) {
      setTimeout((function () {
        this.save(e);
      }).bind(this), 50);
    },

    /**
     * Если пользователь с существующими данными пытается повторно
     * зарегистрироваться через соц. сети. Отправляем в DataLayer
     *
     * @inheritDoc
     */
    fillErrors: function (errors) {
      app.ValidatedFormView.prototype.fillErrors.apply(this, arguments);
      var errorsString = JSON.stringify(errors);
      if (errorsString.indexOf('уже используется') !== -1 && !this.hasDoubleAuthError) {
        this.hasDoubleAuthError = true;
        dataLayer.push({event: 'social_sign_up_error'});
      }
    }
  });
})(jQuery);

}.call(window));